import React, { useContext } from "react";
import { BoundedContent, Divider, FlexBox } from "@vp/swan";
import { PageContext } from "../../types/Global";
import { DebugContext } from "./DebugContextProvider";
import { DebugPageInfo } from "./DebugPageInfo";
import DebugServices from "./DebugServices";
import DebugMpvInfo from "./DebugMpvInfo";

export interface DebugInfoProps {
  pageContext: PageContext;
}

export const DebugInfo = (props: DebugInfoProps) => {
  const { isDebug } = useContext(DebugContext);

  if (!isDebug) {
    return null;
  }

  return (
    <BoundedContent px={"5"}>
      <FlexBox flexDirection="column">
        <DebugPageInfo {...props} />
        <Divider my={"5"} />
        <DebugMpvInfo />
        <Divider my={"5"} />
        <DebugServices />
      </FlexBox>
    </BoundedContent>
  );
};
